import React, { useState, Children } from "react";
import "./burgerMenu.css";
import { Link, useLocation } from 'react-router-dom'
import { Sidebar } from 'primereact/sidebar';
import dip_terra_cotta from "../../images/dipLogo/dip_terra_cotta.png"
import {Trans, useTranslation } from 'react-i18next'
import { IoHome, IoSearch, IoHeart, IoDocument, IoBriefcase, IoPerson, IoClose } from "react-icons/io5";

export const BurgerMenu = ({ itemsMenu }) => {

    const { t } = useTranslation();
    const [visibleLeft, setVisibleLeft] = useState(false);
    const location = useLocation();

    const isActiveLink = (link) => {
        const currentPath = location.pathname;
        
        if (link === '/') {
            return currentPath === '/';
        }
        
        return currentPath === link;
    };

    // Mapping icons for each menu item
    const getMenuIcon = (label) => {
        switch(label) {
            case 'general.home':
            case 'menu.home':
            case 'Accueil':
                return <IoHome className="bm-menu-icon" />;
            case 'search.formations_search':
            case 'search.formations_search_short':
            case 'menu.search_Formations':
            case 'Recherche formations':
                return <IoSearch className="bm-menu-icon" />;
            case 'favorite.myFavorites':
            case 'favorite.myFavorites.full':
            case 'menu.my_favorites_formations':
            case 'Mes formations favorites':
                return <IoHeart className="bm-menu-icon" />;
            case 'offers.myOffers':
            case 'menu.my_offers':
            case 'Mes offres d\'emploi':
                return <IoDocument className="bm-menu-icon" />;
            case 'application.myApplications':
            case 'menu.my_candidatures':
            case 'Mes candidatures':
                return <IoBriefcase className="bm-menu-icon" />;
            case 'profile.myProfile':
            case 'general.myAccount':
            case 'menu.my_profile':
            case 'Mon profil':
                return <IoPerson className="bm-menu-icon" />;
            default:
                return <IoHome className="bm-menu-icon" />;
        }
    };

    return (
        <>
            <Sidebar className="bm-sidebar-container" visible={visibleLeft} baseZIndex={1000000} onHide={() => setVisibleLeft(false)} showCloseIcon={false}>
                <div className='bm-header-container'>
                    <button className="bm-close-btn" onClick={() => setVisibleLeft(false)}>
                        <IoClose />
                    </button>
                    <div className="bm-logo-container">
                        <img 
                            className="bm-logo" 
                            src={dip_terra_cotta} 
                            alt="DiplomAdvisor" 
                            onError={(e) => {
                                console.log('Erreur de chargement du logo:', e);
                                e.target.style.display = 'none';
                            }}
                        />
                    </div>
                </div>
                
                <div className="bm-menu-container">
                    {itemsMenu.map((item, index) => (
                        <Link 
                            key={index}
                            className={`bm-menu-item ${isActiveLink(item.link) ? 'bm-menu-item-active' : ''}`}
                            to={item.link}
                            onClick={() => setVisibleLeft(false)}
                        >
                            {getMenuIcon(item.label)}
                            <span className="bm-menu-text">
                                <Trans i18nKey={item.label} />
                            </span>
                        </Link>
                    ))}
                </div>
            </Sidebar>
            <a href="#" id="openBtn" onClick={() => setVisibleLeft(true)}>
                <span className="burger-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </a>
        </>
    )
}